<template>
    <div class="card p0 shadow">
        <div class="p10 bg-light border-bottom">
            <slot name="back"></slot>

            <!--<button class="btn btn-success pull-right">Opslaan</button>-->
            <!--<button class="btn btn-default pull-right mr10">Annuleren</button>-->
            <spinner size="small" class="pull-right" style="padding-top: 4px" v-if="composerIsLoading"></spinner>
        </div>
        <div class="p30">
            <div class="row">
                <div class="col-md-12">
                    <div class="bg-light fullWidth p20 pt0">
                        <div class="composer">
                            <div class="composer-page grid" ref="page">
                                <composer-row
                                        v-for="row in sortedRows"
                                        :key="row.id+row.updated_at"
                                        :row="row"
                                        :data-id="row.id"
                                        class="composer-row"
                                        @rowEditClicked="handleEditRowClick"
                                        @rowDeleteClicked="handleDeleteRowClick"
                                ></composer-row>

                                <div class="row">
                                    <div class="col-md-12 mt30" >
                                        <button v-if="!loadRowTypes" type="button" class="btn btn-default centerDiv"
                                                @click.prevent="handleAddRowClick">
                                            <i class="fa fa-plus mr5"></i> Rij toevoegen
                                        </button>
                                        <spinner class="centerDiv" size="small" v-else></spinner>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--</div>-->
                        <composer-edit-modal :row="selectedRow" v-if="selectedRow !== null" @update="(newRow) => updatedRow(newRow)" @close="selectedRow = null"></composer-edit-modal>
                        <composer-add-modal v-if="showAddModal" @close="showAddModal = false" :types="rowTypes" @selected="addRowType"></composer-add-modal>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {EventBus} from "../../events";
    import Sortable from 'sortablejs';
    import ComposerRow from './ComposerRow';
    import ComposerEditModal from './ComposerEditModal';
    import ComposerAddModal from './ComposerAddModal';
    import Spinner from './Spinner';

    export default {
        components: {
            Spinner,
            ComposerRow,
            ComposerEditModal,
            ComposerAddModal,
        },
        props: {
            modelId: {
                // Id of Object, will send to backend for creating new Rows.
                type: Number,
                required: true,
            },
            modelType: {
                // MorphMap of Object, will send to backend for creating new Rows.
                type: String,
                required: true,
            },
            rows: {
                required: true,
                type: Array
            },
            trans: {
                required: true,
                type: Object,
            }
        },
        data: function () {
            return {
                showAddModal: false,
                currentRows: null,
                selectedRow: null,
                rowTypes: [],
                loadRowTypes: false,
                composerLoadingArray: []
            }
        },
        methods: {
            addRowType(rowTypeId) {
                if (!this.loadRowTypes) {
                    EventBus.$emit('composer-loading', `addRowType`);
                    this.loadRowTypes = true;
                    let data = {
                        'model_id': this.modelId,
                        'model_type': this.modelType,
                        'row_type_id': rowTypeId,
                    };

                    axios.post(`/api/backend/composer/rows/`, data)
                        .then(response => {
                            let newRow = response.data.data;
                            this.currentRows.push(newRow);
                            this.showAddModal = false;

                            // Open edit modal
                            this.selectedRow = newRow;
                        })
                        .catch(error => {
                            console.log(error);
                        })
                        .finally((response) => {
                            this.loadRowTypes = false;
                            EventBus.$emit('composer-loaded', `addRowType`);
                        });
                }

            },
            getRowTypes() {
                if (!this.loadRowTypes) {
                    this.loadRowTypes = true;
                    EventBus.$emit('composer-loading', `getRowTypes`);
                    axios.get(`/api/backend/composer/rows/get-types/`)
                        .then(response => {
                            this.rowTypes = response.data.data;
                        })
                        .catch(error => {
                            console.log(error);
                        })
                        .finally(response => {
                            this.loadRowTypes = false;
                            EventBus.$emit('composer-loaded', `getRowTypes`);
                        });
                }
            },
            updatedRow(newRow) {
                let position = this.currentRows.findIndex(row => row.id === newRow.id);
                if (Number.isInteger(position)) {
                    this.currentRows.splice(position, 1, newRow);
                }
            },
            handleEditRowClick(row) {
                this.selectedRow = row;
            },
            handleAddRowClick() {
                this.showAddModal = true;
            },
            saveOrder(order) {
                EventBus.$emit('composer-loading', `saveOrder`);

                axios.post(`/api/backend/composer/rows/set-order/`, {
                    order: order
                })
                    .then(response => {
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally(() => {
                        EventBus.$emit('composer-loaded', `saveOrder`);
                    });
            },
            handleDeleteRowClick(row) {
                EventBus.$emit('composer-loading', `handleDeleteRowClick-${row.id}`);


                axios.post(`/api/backend/composer/rows/${row.id}/`, {
                    '_method': 'delete'
                })
                    .then(response => {
                    })
                    .catch(error => {
                        console.log(error);
                        this.forceRefresh();
                    })
                    .finally(response => {
                        EventBus.$emit('composer-loaded', `handleDeleteRowClick-${row.id}`);
                    });
            },
            forceRefresh() {
                // location.reload();
            }
        },
        computed: {
            modal() {
                return $(this.$refs.modal);
            },
            sortedRows() {
                return _.sortBy(this.currentRows, ['order'])
            },
            composerIsLoading() {
                return this.composerLoadingArray.length > 0
            }
        },
        watch: {},
        mounted() {
            this.currentRows = this.rows;

            let grid = (function () {
                let module = function (grid, options) {
                    this._$grid = grid;
                    this._options = options;
                };

                module.prototype = {
                    constructor: module,

                    initialize: function () {
                        Sortable.create(this._$grid, this._options);
                    },

                    serialize: function () { /* TODO */
                    }
                };

                return module;
            })();

            new grid(document.querySelector(".grid"), {
                animation: 200,
                draggable: '.card',
                handle: '.card',
                store: {
                    set: (sortable) => {
                        let order = sortable.toArray();
                        this.saveOrder(order);
                    }
                }
            }).initialize();

            this.$store.commit('setTranslations', this.trans);
        },
        created() {
            EventBus.$on('composer-loading', payload => {
                this.composerLoadingArray.push(payload);
            });

            EventBus.$on('composer-loaded', payload => {
                for (let i = 0; i < this.composerLoadingArray.length; i++) {
                    if (this.composerLoadingArray[i] === payload) {
                        this.composerLoadingArray.splice(i, 1);
                    }
                }
            });

            this.getRowTypes();
        }

    }
</script>

<style scoped>

</style>
